export default __webpack_public_path__ + "static/media/to_up_arrow.3bfa79da.svg";